const tables = [
  {
    name: "Account Name",
  },
  {
    name: "Code",
  },
  {
    name: "Type",
  },
  {
    name: "Category",
  },
  {
    name: "Status",
  },
  {
    name: "Balance",
  }
];

export default tables;
